import React, { useState, useEffect } from "react";
import { Filters } from "../../../components/Drawer/Requests/Filters";
import { CreateRequest } from "../../../components/Drawer/Requests/CreateRequest";
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import { toastNotification } from "../../../utils/toastNotification";
import { EditRequest } from "../../../components/Drawer/Requests/EditRequests/EditRequest";
import { permissionsFilter } from "../../../utils/permissionsFilter";
import RequestsTable from "../../../components/Tables/Requests";
import Api from "../../../api";
import "../../../public/sass/pages/_open.scss";

const OpenRequestsContainer = () => {
  const { t, i18n } = useTranslation();
  const [isVisibleCreate, setVisibleCreate] = useState(false);
  const [modalState, setModal] = useState({ id: "", mode: "", isOpen: false });
  const [loading, setLoading] = useState(true);
  const [editData, setData] = useState([]);
  const [requests, setRequests] = useState([]);

  const onSearch = (value) => console.log(value);

  const toggleDrawer = () => setVisibleCreate(!isVisibleCreate);

  const handleModal = (mode, isOpen, id) => {
    setModal({
      ...modalState,
      ["mode"]: mode,
      ["isOpen"]: isOpen,
      ["id"]: id,
    });
  };

  useEffect(() => {
    getOpenRequests();
  }, []);

  const getOpenRequests = () => {
    Api("requests/type/open", "GET")
      .then((data) => {
        setRequests(data.results);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const getRequestById = (id) => {
    setLoading(true);
    Api("requests/" + id, "GET", null)
      .then((data) => {
        setData(data);
        handleModal("edit", true, id);
        setLoading(false);
      })
      .catch((err) => {
        toastNotification("error", err.error || `${t("something_went_wrong")}`);
        setLoading(false);
      });
  };

  const deleteRequest = (id) => {
    if (!id) return message.error("Id is missing!");
    Api("requests/" + id, "DELETE", null)
      .then(() => {
        toastNotification("success", `${t("user_successfully_deleted")}`);
        getOpenRequests();
      })
      .catch(() => toastNotification("error", `${t("error_delete_user")}`));
  };

  return (
    <div className="open-container">
      <div className="header">
        <Filters {...onSearch} />
        <CreateRequest
          isVisible={isVisibleCreate}
          onClose={toggleDrawer}
          getOpenRequests={getOpenRequests}
          requests={requests}
        />
        {permissionsFilter('Open Requests', 'OpenRequestCreate') &&
          <Button className="button" onClick={toggleDrawer}>
            {t("add_open_request")}
          </Button>
        }
      </div>
      <EditRequest
        getOpenRequests={getOpenRequests}
        data={editData}
        id={modalState.id}
        isVisible={modalState.mode == "edit" && modalState.isOpen}
        onClose={handleModal}
        requests={requests}
        type="open"
      />
      <RequestsTable
        requests={requests}
        getRequestById={getRequestById}
        deleteRequest={deleteRequest}
        loading={loading}
      />
    </div>
  );
};
export default OpenRequestsContainer;
